const mediaItems = [
  {
    title: '《光影传奇》幕后探秘：一部好片是如何诞生的',
    desc: '从剧本围读到后期调色，带你走进电影制作的每一个环节，揭秘银幕背后的匠心故事。',
    duration: '18:24',
    views: '32.6万',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20set%20behind%20the%20scenes%20with%20camera%20crew%2C%20warm%20production%20lighting%2C%20professional%20movie%20making%20atmosphere%2C%20director%20chair%2C%20film%20equipment%2C%20soft%20golden%20tones%2C%20rich%20contrast%20cinematography&width=800&height=450&seq=media-card-01-v2&orientation=landscape',
    imgAlt: '电影幕后制作花絮',
  },
  {
    title: '本周院线速递：五部必看新片全解析',
    desc: '最新上映的院线大片逐一点评，剧情、演技、视效全面对比，帮你挑出最值回票价的观影选择。',
    duration: '12:06',
    views: '18.9万',
    img: 'https://readdy.ai/api/search-image?query=Modern%20movie%20theater%20lobby%20with%20film%20posters%20displayed%2C%20warm%20ambient%20lighting%2C%20elegant%20cinema%20decor%2C%20red%20carpet%2C%20premium%20theater%20design%2C%20professional%20interior%20photography&width=800&height=450&seq=media-card-02-v2&orientation=landscape',
    imgAlt: '院线新片推荐',
  },
  {
    title: '经典重温：《教父》系列为何被誉为影史巅峰',
    desc: '跨越半个世纪的传奇三部曲，从叙事结构到镜头语言，拆解这部伟大作品的不朽魅力所在。',
    duration: '25:41',
    views: '45.2万',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20film%20projector%20with%20warm%20glowing%20beam%20of%20light%2C%20film%20reels%2C%20classic%20cinema%20aesthetic%2C%20dust%20particles%20floating%20in%20light%2C%20nostalgic%20dark%20room%2C%20professional%20photography%20rich%20texture&width=800&height=450&seq=media-card-03-v2&orientation=landscape',
    imgAlt: '经典影片回顾',
  },
];

export default function SectionMedia() {
  return (
    <section id="media" className="bg-background-100 py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap mb-3">
            精彩花絮
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            影视周边 · 深度解读
          </h2>
          <p className="text-foreground-600 text-sm mt-2">幕后故事、新片速递与经典解读，拓展你的观影视野</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 group cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.imgAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/80 backdrop-blur-sm group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-background-50 text-xl md:text-2xl"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 rounded text-background-50 text-xs whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 mb-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}